const metaSourcePref =
  [
    {
      "sourceId": "a01",
      "source": "・国勢調査実施年<br>総務省統計局<br>　「国勢調査報告」<br>　＜５年毎＞<br>　人口等基本集計<br>・国勢調査実施年以外<br>　総務省統計局<br>　「人口推計」<br>　＜毎年＞"
    },
    {
      "sourceId": "a02",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a03",
      "source": "・国勢調査実施年<br>　総務省統計局<br>　「国勢調査報告」<br>　＜５年毎＞<br>　人口等基本集計<br>・国勢調査実施年以外<br>　総務省統計局<br>　「人口推計」<br>　＜毎年＞"
    },
    {
      "sourceId": "a04",
      "source": "総務省統計局 <br>「国勢調査報告」  <br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a05",
      "source": "・国勢調査実施年<br>　総務省統計局<br>　「国勢調査報告」<br>　＜５年毎＞<br>人口等基本集計<br>・国勢調査実施年以外<br>　総務省統計局<br>　「人口推計」<br>　＜毎年＞"
    },
    {
      "sourceId": "a06",
      "source": "総務省統計局 <br>「国勢調査報告」  <br>＜５年毎＞人口等基本集計"
    },
    {
      "sourceId": "a07",
      "source": "総務省統計局 <br>「国勢調査報告」  <br>＜５年毎＞人口等基本集計"
    },
    {
      "sourceId": "a08",
      "source": "総務省統計局<br>「国勢調査報告」  <br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a09",
      "source": "総務省統計局 <br>「国勢調査報告」  <br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a10",
      "source": "国立社会保障・人口問題研究所<br>「日本の将来推計人口」"
    },
    {
      "sourceId": "a11",
      "source": "総務省自治行政局<br>「住民基本台帳人口要覧」  <br>＜毎年＞"
    },
    {
      "sourceId": "a12",
      "source": "総務省自治行政局<br>「住民基本台帳人口要覧」<br>法務省入国管理局<br>「登録外国人統計調査」"
    },
    {
      "sourceId": "a13",
      "source": "総務省自治財政局<br>「住民基本台帳人口要覧」＜毎年＞"
    },
    {
      "sourceId": "a14",
      "source": "法務省入国管理局<br>「登録外国人統計調査」<br>＜毎年＞"
    },
    {
      "sourceId": "a15",
      "source": "法務省入国管理局<br>「在留外国人統計」<br>＜毎年＞"
    },
    {
      "sourceId": "a16",
      "source": "厚生労働省政策統括官付参事官付<br>「人口動態統計」<br>＜毎年＞"
    },
    {
      "sourceId": "a17",
      "source": "厚生労働省政策統括官付参事官付<br>｢都道府県別年齢調整死亡率」<br>＜５年毎＞"
    },
    {
      "sourceId": "a18",
      "source": "厚生労働省政策統括官付参事官付<br> 「人口動態統計」<br>＜毎年＞"
    },
    {
      "sourceId": "a19",
      "source": "国立社会保障・人口問題研究所<br>「人口問題研究」<br>＜５年毎＞"
    },
    {
      "sourceId": "a20",
      "source": "総務省統計局<br>「住民基本台帳人口移動報告年報」<br>＜毎年＞"
    },
    {
      "sourceId": "a21",
      "source": "総務省統計局<br>「人口推計」      <br>＜毎年＞      <br>国勢調査実施年は収集休止"
    },
    {
      "sourceId": "a22",
      "source": "総務省統計局<br>「国勢調査報告」  <br>＜５年毎＞<br>従業地・通学地集計<br>従業地・通学地による人口・就業状態等集計"
    },
    {
      "sourceId": "a23",
      "source": "総務省統計局<br>「国勢調査報告」  <br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a24",
      "source": "総務省自治行政局<br>「住民基本台帳人口要覧」<br>＜毎年＞"
    },
    {
      "sourceId": "a25",
      "source": "総務省統計局<br>「国勢調査報告」  <br>＜５年毎＞<br>人口等基本集計"
    },
    {
      "sourceId": "a26",
      "source": "総務省統計局<br>「国勢調査報告」  <br>＜５年毎＞<br>産業等基本集計<br>世帯構造等基本集計"
    },
    {
      "sourceId": "a27",
      "source": "厚生労働省政策統括官付参事官付<br>「人口動態統計」  <br>＜毎年＞"
    },
    {
      "sourceId": "b01",
      "source": "・国勢調査実施年<br>　総務省統計局<br>　「国勢調査報告」<br>　＜５年毎＞<br>・国勢調査実施年以外<br>　国土交通省国土地理院<br>＜毎年＞"
    },
    {
      "sourceId": "b02",
      "source": "農林水産省大臣官房統計部<br>「世界農林業センサス・林業地域調査報告書」<br><10年毎>"
    },
    {
      "sourceId": "b03",
      "source": "環境省自然環境局　HP<br>「自然環境保全地域各種データ」<br>＜毎年＞"
    },
    {
      "sourceId": "b04",
      "source": "総務省自治税務局<br>「固定資産の価格等の概要調書（土地）」<br>＜毎年＞"
    },
    {
      "sourceId": "b05",
      "source": "林野庁林政部<br>「森林・林業統計要覧」＜毎年＞"
    },
    {
      "sourceId": "b06",
      "source": "環境省自然環境局<br>「自然公園の面積」<br>＜毎年＞"
    },
    {
      "sourceId": "b07",
      "source": "環境省自然環境局<br>「自然環境保全基礎調査報告書」<br>＜不定期＞"
    },
    {
      "sourceId": "b08",
      "source": "気象庁観測部<br>「過去の気象データ」<br>＜毎年＞<br>数値は，各都道府県庁所在市の観測値。<br>ただし，東京都は千代田区，埼玉県は熊谷市，滋賀県は彦根市。<br>さらに，B4104快晴日数（年間）の2017年以降のデータは千葉県は銚子市，山口県は下関市。"
    },
    {
      "sourceId": "c01",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成17年基準"
    },
    {
      "sourceId": "c02",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成23年基準"
    },
    {
      "sourceId": "c03",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>平成17年基準"
    },
    {
      "sourceId": "c04",
      "source": "総務省自治税務局<br>「市町村税課税状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "c05",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成17年基準"
    },
    {
      "sourceId": "c06",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成23年基準"
    },
    {
      "sourceId": "c07",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成17年基準"
    },
    {
      "sourceId": "c08",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成23年基準"
    },
    {
      "sourceId": "c09",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成17年基準"
    },
    {
      "sourceId": "c10",
      "source": "内閣府経済社会総合研究所国民経済計算部<br>「県民経済計算年報」<br>＜毎年＞<br>平成23年基準"
    },
    {
      "sourceId": "c110",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c11",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c12",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c13",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜不定＞"
    },
    {
      "sourceId": "c14",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c15",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c16",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c17",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c18",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c19",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c20",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c21",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞<br>総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜不定＞"
    },
    {
      "sourceId": "c22",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c23",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c24",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c25",
      "source": "総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c26",
      "source": "農林水産省大臣官房統計部<br>「生産農業所得統計」<br>＜毎年＞"
    },
    {
      "sourceId": "c27",
      "source": "農林水産省大臣官房統計部<br>「農林業センサス」，「農業センサス」<br>＜５年毎＞"
    },
    {
      "sourceId": "c28",
      "source": "農業センサス実施年<br>農林水産省大臣官房統計部<br>「世界農林業センサス」<br>＜１０年毎＞<br><br>H18年まで<br>農業センサス実施年以外<br>農林水産省大臣官房統計部<br>「農業構造動態調査報告」"
    },
    {
      "sourceId": "c29",
      "source": "農林水産省大臣官房統計部<br>「耕地及び作付面積統計」<br>＜毎年＞"
    },
    {
      "sourceId": "c30",
      "source": "農林水産省大臣官房統計部<br>「農地の移動と転用」<br>＜毎年＞"
    },
    {
      "sourceId": "c31",
      "source": "農林水産省大臣官房統計部<br>「農林業センサス」，「農業センサス」<br>＜５年毎＞"
    },
    {
      "sourceId": "c32",
      "source": "農林水産省大臣官房統計部<br>「木材需給報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "c33",
      "source": "林野庁林政部<br>「特用林産物需給表」< br>＜毎年＞"
    },
    {
      "sourceId": "c34",
      "source": "林野庁林政部<br>「林業統計要覧」<br>＜毎年＞"
    },
    {
      "sourceId": "c35",
      "source": "農林水産省大臣官房統計部生産統計室<br>｢漁業・養殖業生産統計年報」<br>＜毎年＞"
    },
    {
      "sourceId": "c36",
      "source": "農林水産省大臣官房統計部生産統計室<br>「漁業センサス」<br>＜５年＞<br>H14年までは,「漁業就業動向統計年報」"
    },
    {
      "sourceId": "c37",
      "source": "農林水産省大臣官房統計部<br>「６次産業化総合調査」<br>＜毎年＞"
    },
    {
      "sourceId": "c38",
      "source": "国土交通省総合政策局情報管理部<br>「建築統計年報」<br>＜毎年＞"
    },
    {
      "sourceId": "c39",
      "source": "国土交通省総合政策局情報管理部<br>｢建設工事施工統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "c40",
      "source": "経済産業省大臣官房調査統計グループ<br>「工業統計表」＜毎年＞<br>総務省統計局及び経済産業省大臣官房調査統計グループ<br>「経済センサス－活動調査」<br>＜５年＞"
    },
    {
      "sourceId": "c41",
      "source": "経済産業省経済産業政策局<br>「商業統計表」<br>＜不定＞<br>総務省統計局及び経済産業省大臣官房調査統計グループ<br>「経済センサス－活動調査」<br>＜不定＞"
    },
    {
      "sourceId": "c42",
      "source": "日本銀行調査統計局<br>「ホームページ」<br>＜毎年＞"
    },
    {
      "sourceId": "c43",
      "source": "国土交通省総合政策局情報管理部<br>「貨物地域流動調査」<br>＜毎年＞"
    },
    {
      "sourceId": "c44",
      "source": "国土交通省総合政策局情報管理部<br>「旅客地域流動調査」<br>＜毎年＞"
    },
    {
      "sourceId": "c45",
      "source": "国土交通省総合政策局情報管理部<br>「貨物地域流動調査」<br>＜毎年＞"
    },
    {
      "sourceId": "c46",
      "source": "国土交通省総合政策局情報管理部<br>「旅客地域流動調査」<br>＜毎年＞"
    },
    {
      "sourceId": "c47",
      "source": "国土交通省総合政策局情報管理部<br>「港湾統計年報」<br>＜毎年＞"
    },
    {
      "sourceId": "c48",
      "source": "国土交通省総合政策局情報管理部<br>「交通関連統計資料集」<br>＜毎年＞"
    },
    {
      "sourceId": "c49",
      "source": "国土交通省総合政策局情報管理部<br>「自動車保有車両数」<br>＜毎年＞"
    },
    {
      "sourceId": "c50",
      "source": "国土交通省総合政策局情報管理部<br>「交通関連統計資料集」<br>＜毎年＞"
    },
    {
      "sourceId": "c51",
      "source": "国土交通省総合政策局<br>「自動車輸送統計調査」"
    },
    {
      "sourceId": "c52",
      "source": "厚生労働省政策統括官付参事官付<br>「衛生行政報告例」<br>＜毎年＞"
    },
    {
      "sourceId": "c53",
      "source": "総務省統計局<br>「消費者物価指数年報」<br> 数値は，各都道府県の県庁 所在市の結果。"
    },
    {
      "sourceId": "c54",
      "source": "総務省統計局<br>「全国物価統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "c55",
      "source": "総務省統計局<br>｢消費者物価指数月報」(５月）<br>＜毎年＞"
    },
    {
      "sourceId": "c56",
      "source": "国土交通省土地・水資源局地価調査課<br>＜毎年＞"
    },
    {
      "sourceId": "c57",
      "source": "総務省統計局<br>「消費者物価指数年報」<br>＜毎年＞"
    },
    {
      "sourceId": "c58",
      "source": "総務省統計局<br>「小売物価統計調査（構造編）」"
    },
    {
      "sourceId": "c59",
      "source": "総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜不定＞<br>総務省統計局<br>「経済センサス－基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "c60",
      "source": "総務省統計局，経済産業省大臣官房調査統計グループ<br>「経済センサス-活動調査」<br>＜不定＞"
    },
    {
      "sourceId": "c61",
      "source": "総務省統計局<br>「サービス産業動向調査」（拡大調査（年次調査）"
    },
    {
      "sourceId": "d01",
      "source": "総務省自治行政局市町村課<br>「全国地方公共団体コード｣<br>＜毎年＞<br>｢地方公共団体定員管理調査」<br>＜毎年＞"
    },
    {
      "sourceId": "d02",
      "source": "総務省自治行政局選挙部<br>「地方公共団体の議会及び長の所属党派別人員調等について」"
    },
    {
      "sourceId": "d03",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「都道府県決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d04",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d05",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「都道府県決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d06",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d07",
      "source": "総務省自治財政局<br>「地方財政統計年報」<br>「都道府県決算状況調」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d08",
      "source": "国税庁長官官房企画課<br>「国税庁統計年報書｣<br>＜毎年＞"
    },
    {
      "sourceId": "d09",
      "source": "総務省自治財政局 <br>「都道府県決算状況調」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d10",
      "source": "国税庁長官官房企画課<br>「国税庁統計年報書｣<br>＜毎年＞"
    },
    {
      "sourceId": "d11",
      "source": "総務省自治財政局 <br>「都道府県決算状況調」<br>「市町村別決算状況調」<br>＜毎年＞"
    },
    {
      "sourceId": "d12",
      "source": "総務省自治行政局地域振興室<br>「行政投資実績」<br>＜毎年＞"
    },
    {
      "sourceId": "d13",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "e01",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e02",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "e03",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜３年＞"
    },
    {
      "sourceId": "e04",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "e05",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜３年＞"
    },
    {
      "sourceId": "e06",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e07",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e08",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "e09",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜３年＞"
    },
    {
      "sourceId": "e10",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "e11",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜３年＞"
    },
    {
      "sourceId": "e12",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e13",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e14",
      "source": "都道府県担当課<br>「都道府県資料」<br><毎年>"
    },
    {
      "sourceId": "e15",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜３年＞"
    },
    {
      "sourceId": "e16",
      "source": "都道府県担当課<br>「都道府県資料」<br><毎年>"
    },
    {
      "sourceId": "e17",
      "source": "総務省自治財政局<br>「公共施設状況調」<br>＜３年＞"
    },
    {
      "sourceId": "e18",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e19",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e20",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e22",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e23",
      "source": "文部科学省「学校基本調査」より提供を受け総務省統計局で集計<br>＜毎年＞<br>H21年までは,都道府県担当課<br>「都道府県資料」"
    },
    {
      "sourceId": "e24",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e25",
      "source": "文部科学省生涯学習政策局調査企画課<br>「学校基本調査報告書」<br>＜毎年＞<br>H21年までは,都道府県担当課<br>「都道府県資料」"
    },
    {
      "sourceId": "e26",
      "source": "文部科学省生涯学習政策局調査企画課<br>「地方教育費調査報告書」<br>＜毎年＞"
    },
    {
      "sourceId": "e27",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜10年毎＞<br>大規模調査のみ産業等基本集計"
    },
    {
      "sourceId": "e28",
      "source": "文部科学省生涯学習政策局情報教育課<br>「学校における教育の情報化の実態等に関する調査結果」<br>＜毎年＞"
    },
    {
      "sourceId": "e29",
      "source": "総務省統計局<br>「サービス産業動向調査」（拡大調査（年次調査）"
    },
    {
      "sourceId": "f01",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>産業等基本集計<br>就業状態等基本集計"
    },
    {
      "sourceId": "f02",
      "source": "総務省統計局<br>「就業構造基本調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "f03",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>抽出詳細集計"
    },
    {
      "sourceId": "f04",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>産業等基本集計<br>就業状態等基本集計"
    },
    {
      "sourceId": "f05",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>職業等基本集計<br>世帯構造等基本集計"
    },
    {
      "sourceId": "f06",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞産業等基本集計<br>就業状態等基本集計"
    },
    {
      "sourceId": "f07",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>産業等基本集計<br>就業状態等基本集計"
    },
    {
      "sourceId": "f08",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>産業等基本集計<br>（第２次基本集計）<br>就業状態等基本集計"
    },
    {
      "sourceId": "f09",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>産業等基本集計<br>就業状態等基本集計"
    },
    {
      "sourceId": "f10",
      "source": "総務省統計局<br>「就業構造基本調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "f11",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>第３次基本集計"
    },
    {
      "sourceId": "f12",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>職業等基本集計<br>（平成21年12月統計基準設定）<br>就業状態等基本集計"
    },
    {
      "sourceId": "f13",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br> 従業地・通学地集計<br>従業地・通学地による人口・就業状態等集計"
    },
    {
      "sourceId": "f14",
      "source": "厚生労働省職業安定局<br>「労働市場年報」<br>＜毎年＞"
    },
    {
      "sourceId": "f15",
      "source": "厚生労働省政策統括官付参事官付<br>｢賃金構造基本統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f16",
      "source": "厚生労働省職業安定局<br>「労働市場年報」<br>＜毎年＞"
    },
    {
      "sourceId": "f17",
      "source": "厚生労働省政策統括官付参事官付<br>｢賃金構造基本統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f18",
      "source": "厚生労働省職業安定局<br>「新規学卒者の労働市場」<br>＜毎年＞"
    },
    {
      "sourceId": "f19",
      "source": "厚生労働省職業安定局<br>「労働市場年報」<br>＜毎年＞"
    },
    {
      "sourceId": "f20",
      "source": "厚生労働省政策統括官付参事官付<br>｢賃金構造基本統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f21",
      "source": "厚生労働省職業安定局<br>「労働市場年報」"
    },
    {
      "sourceId": "f22",
      "source": "総務省統計局<br>「就業構造基本調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "f23",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "f24",
      "source": "厚生労働省政策統括官付参事官付<br>｢賃金構造基本統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f25",
      "source": "厚生労働省政策統括官付参事官付<br>｢賃金構造基本統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f26",
      "source": "厚生労働省政策統括官付参事官付<br>「毎月勤労統計調査」<br>＜毎月＞"
    },
    {
      "sourceId": "f27",
      "source": "厚生労働省政策統括官付参事官付<br>｢賃金構造基本統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f28",
      "source": "厚生労働省労働基準局労働条件政策課<br>「地域別最低賃金の全国一覧」"
    },
    {
      "sourceId": "f29",
      "source": "厚生労働省政策統括官付参事官付<br>「労働災害動向調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f30",
      "source": "厚生労働省政策統括官付参事官付<br>「労働組合基礎調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "f31",
      "source": "厚生労働省政策統括官付参事官付<br>「労働争議統計調査年報告」<br>＜毎年＞"
    },
    {
      "sourceId": "g01",
      "source": "文部科学省生涯学習政策局調査企画課<br>「社会教育調査報告書」<br>＜３年毎＞"
    },
    {
      "sourceId": "g02",
      "source": "文部科学省生涯学習政策局調査企画課<br>「社会教育調査報告書」<br>＜３年毎＞"
    },
    {
      "sourceId": "g03",
      "source": "文部科学省生涯学習政策局調査企画課<br>「社会教育調査報告書」<br>＜３年毎＞"
    },
    {
      "sourceId": "g04",
      "source": "都道府県担当課<br>「都道府県資料」<br>＜毎年＞"
    },
    {
      "sourceId": "g05",
      "source": "文部科学省生涯学習政策局調査企画課<br>「社会教育調査報告書」<br>＜３年毎＞"
    },
    {
      "sourceId": "g06",
      "source": "文部科学省生涯学習政策局調査企画課<br>「社会教育調査報告書」<br>＜３年毎＞"
    },
    {
      "sourceId": "g07",
      "source": "文部科学省生涯学習政策局調査企画課<br>「文部科学統計要覧」<br>＜毎年＞"
    },
    {
      "sourceId": "g08",
      "source": "文化庁文化部宗務課<br>「宗教年鑑」<br>＜毎年＞"
    },
    {
      "sourceId": "g09",
      "source": "厚生労働省政策統括官付参事官付<br>「衛生行政報告例」<br>＜毎年＞"
    },
    {
      "sourceId": "g10",
      "source": "厚生労働省政策統括官付参事官付<br>「衛生行政報告例」<br>＜毎年＞"
    },
    {
      "sourceId": "g11",
      "source": "外務省大臣官房領事移住部<br>「旅券統計」<br>＜毎年＞"
    },
    {
      "sourceId": "g12",
      "source": "経済産業省経済産業政策局調査統計部<br>「商業統計表」（産業編）<br>＜３年毎＞"
    },
    {
      "sourceId": "g13",
      "source": "厚生労働省政策統括官付参事官付人口動態・保健統計課<br>「社会福祉行政業務報告」<br>＜毎年＞"
    },
    {
      "sourceId": "g14",
      "source": "内閣府NPOホームページ<br>＜毎年＞"
    },
    {
      "sourceId": "g15",
      "source": "日本赤十字社<br>「血液事業統計資料～血液事業の現状～」<br>＜毎年＞"
    },
    {
      "sourceId": "g16",
      "source": "総務省自治行政局選挙部<br>「衆議院議員総選挙最高裁判所裁判官国民審査」<br>＜選挙年＞"
    },
    {
      "sourceId": "g17",
      "source": "総務省自治行政局選挙部<br>｢参議院議員通常選挙結果調」<br>＜選挙年＞"
    },
    {
      "sourceId": "g18",
      "source": "総務省自治行政局選挙部<br>「地方選挙結果調」<br>＜選挙年＞"
    },
    {
      "sourceId": "g19",
      "source": "総務省統計局<br>「社会生活基本調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "g20",
      "source": "総務省統計局<br>「社会生活基本調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "g21",
      "source": "観光庁観光戦略課<br>「宿泊旅行統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "h01",
      "source": "総務省統計局<br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h02",
      "source": "総務省統計局<br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h03",
      "source": "国土交通省総合政策局情報管理部<br>「建築統計年報」<br>「建築着工統計調査」<br>＜毎年＞"
    },
    {
      "sourceId": "h04",
      "source": "総務省統計局<br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h05",
      "source": "国土交通省総合政策局情報管理部<br>「建築統計年報」<br>「建築着工統計調査」<br>＜毎年＞"
    },
    {
      "sourceId": "h06",
      "source": "総務省統計局<br>「住宅・土地統計調査報告｣<br>＜５年毎＞"
    },
    {
      "sourceId": "h07",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計<br>（職業等基本集計、１次基本集計）<br>世帯構造等基本集計"
    },
    {
      "sourceId": "h08",
      "source": "総務省統計局 <br>「住宅・土地統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h09",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>人口等基本集計（１次基本集計）"
    },
    {
      "sourceId": "h10",
      "source": "総務省統計局<br>「住宅・土地統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h11",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h12",
      "source": "総務省統計局<br>「住宅・土地統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h13",
      "source": "総務省統計局<br>「小売物価統計調査年報」<br>＜毎年＞<br>数値は，各都道府県の県庁所在市の結果。"
    },
    {
      "sourceId": "h14",
      "source": "住宅金融公庫<br>「公庫融資利用者調査報告－マイホーム新築融資編－｣<br>＜毎年＞"
    },
    {
      "sourceId": "h15",
      "source": "国土交通省総合政策局情報管理部<br>「建築統計年報」「建築着工統計調査」<br>＜毎年＞"
    },
    {
      "sourceId": "h16",
      "source": "電気事業連合会<br>「電気事業便覧」<br>新エネルギー・産業技術総合開発機構<br>「日本における都道府県別風力発電導入量」<br>＜毎年＞"
    },
    {
      "sourceId": "h17",
      "source": "経済産業省資源エネルギー庁<br>「電気事業便覧」"
    },
    {
      "sourceId": "h18",
      "source": "資源エネルギー庁電力・ガス事業部<br>「ガス事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "h19",
      "source": "石油連盟<br>都道府県石油精製品販売総括<br>＜毎年＞"
    },
    {
      "sourceId": "h20",
      "source": "資源エネルギー庁電力・ガス事業部<br>「ガス事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "h21",
      "source": "日本水道協会<br>「水道統計」<br>＜毎年＞"
    },
    {
      "sourceId": "h22",
      "source": "日本水道協会「水道統計　施設・業務編」<br>＜毎年＞"
    },
    {
      "sourceId": "h23",
      "source": "日本下水道協会<br>「下水道統計」（行政編）<br>＜毎年＞"
    },
    {
      "sourceId": "h24",
      "source": "環境省大臣官房<br>廃棄物・リサイクル対策部<br>「日本の廃棄物処理」<br>＜毎年＞"
    },
    {
      "sourceId": "h25",
      "source": "資源エネルギー庁総合政策課<br>「都道府県別エネルギー消費統計調査」"
    },
    {
      "sourceId": "h26",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h27",
      "source": "総務省統計局<br>「経済センサス―基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "h28",
      "source": "総務省統計局<br>「事業所・企業統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h29",
      "source": "総務省統計局<br>「経済センサス―基礎調査」<br>＜５年毎＞"
    },
    {
      "sourceId": "h30",
      "source": "経済産業省経済産業政策局調査統計グループ<br>「商業統計表」<br>（業態別統計編）<br>＜不定＞"
    },
    {
      "sourceId": "h31",
      "source": "厚生労働省政策統括官付参事官付<br>「衛生行政報告例」<br>＜毎年＞"
    },
    {
      "sourceId": "h32",
      "source": "資源エネルギー庁石油流通課<br>「HP：揮発油販売業者及び給油所の推移（登録ベース）」<br>＜毎年＞"
    },
    {
      "sourceId": "h33",
      "source": "経済産業省経済産業政策局調査統計グループ<br>「商業統計表」<br>産業編<br>＜不定＞"
    },
    {
      "sourceId": "h34",
      "source": "国土交通省道路局<br>「道路統計年報」<br>＜毎年＞"
    },
    {
      "sourceId": "h35",
      "source": "国土交通省道路局<br>「全国道路・街路交通情勢調査」"
    },
    {
      "sourceId": "h36",
      "source": "総務省自治税務局市町村税課<br>「軽自動車税に関する調」<br>＜毎年＞"
    },
    {
      "sourceId": "h37",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜１０年毎＞<br>大規模調査のみ<br>従業地・通学地集計"
    },
    {
      "sourceId": "h38",
      "source": "総務省統計局<br>「住宅・土地統計調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "h39",
      "source": "郵便局株式会社<br>「郵便局局数情報（ＨＰ）」<br>＜毎年＞"
    },
    {
      "sourceId": "h40",
      "source": "日本電信電話株式会社<br>「電気通信役務契約等状況報告」<br>＜毎年＞"
    },
    {
      "sourceId": "h41",
      "source": "総務省総合通信基盤局料金サービス課<br>「通信量からみた我が国の音声通信利用状況」<br>＜毎年＞"
    },
    {
      "sourceId": "h42",
      "source": "日本放送協会<br>「放送受信契約数統計要覧」<br]>＜毎年＞"
    },
    {
      "sourceId": "h43",
      "source": "総務省情報流通行政局<br>「ケーブルテレビの現状」<br>＜毎年＞"
    },
    {
      "sourceId": "h44",
      "source": "総務省総合通信基盤局電気通信部データ通信課<br>「電気通信サービスの契約数及びシェアに関する四半期データの公表」<br>＜毎年＞"
    },
    {
      "sourceId": "h45",
      "source": "国土交通省都市局<br>「都市計画年報」<br>＜毎年＞"
    },
    {
      "sourceId": "h46",
      "source": "国土交通省都市局<br>「都市公園整備現況」<br>＜毎年＞"
    },
    {
      "sourceId": "j01",
      "source": "厚生労働省社会・援護局<br>「被保護者調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j02",
      "source": "厚生労働省政策統括官付参事官付<br>「福祉行政報告例」<br>＜毎年＞"
    },
    {
      "sourceId": "j03",
      "source": "厚生労働省政策統括官付参事官付<br>｢衛生行政報告例｣<br>＜毎年＞"
    },
    {
      "sourceId": "j04",
      "source": "厚生労働省政策統括官付参事官付<br>「福祉行政報告例」<br>＜毎年＞"
    },
    {
      "sourceId": "j05",
      "source": "厚生労働省政策統括官付参事官付<br>「介護サービス施設・事業所調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j06",
      "source": "厚生労働省政策統括官付参事官付<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j07",
      "source": "厚生労働省政策統括官付参事官付<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j08",
      "source": "厚生労働省政策統括官付参事官付<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j09",
      "source": "厚生労働省雇用均等・児童家庭局<br>「保育所関連状況取りまとめ」<br>＜毎年＞"
    },
    {
      "sourceId": "j10",
      "source": "厚生労働省政策統括官付参事官付<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j11",
      "source": "内閣府子ども・子育て本部<br>「認定こども園」"
    },
    {
      "sourceId": "j12",
      "source": "厚生労働省政策統括官付参事官付<br>「社会福祉施設等調査」＜毎年＞"
    },
    {
      "sourceId": "j13",
      "source": "厚生労働省政策統括官付参事官付<br>「地域児童福祉事業等調査」<br>＜３年＞"
    },
    {
      "sourceId": "j14",
      "source": "厚生労働省政策統括官付参事官付<br>「社会福祉施設等調査」<br>＜毎年＞"
    },
    {
      "sourceId": "j15",
      "source": "厚生労働省政策統括官付参事官付<br>「福祉行政報告例」"
    },
    {
      "sourceId": "j16",
      "source": "都道府県担当課 <br>「都道府県資料」"
    },
    {
      "sourceId": "j17",
      "source": "厚生労働省政策統括官付参事官付<br>「社会福祉行政業務報告」<br>＜毎年＞"
    },
    {
      "sourceId": "j18",
      "source": "厚生労働省政策統括官付参事官付<br>「国民医療費」<br>＜毎年＞<br>1999年～2014年までは３年周期"
    },
    {
      "sourceId": "j19",
      "source": "厚生労働省保険局調査課<br>「国民健康保険事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j20",
      "source": "全国健康保険協会<br>「事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j21",
      "source": "社会保険庁運営部<br>「事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j22",
      "source": "厚生労働省保健局調査課<br>「健康保険組合事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j23",
      "source": "社会保険庁運営部<br>「事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j24",
      "source": "社会保険庁運営部<br>「事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j25",
      "source": "厚生労働省保険局<br>「後期高齢者事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j26",
      "source": "厚生労働省年金局<br>「厚生年金保険・国民年金事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j27",
      "source": "労働労働省職業安定局<br>「雇用保険事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j28",
      "source": "社会保険庁運営部<br>「事業年報」<br>＜毎年＞"
    },
    {
      "sourceId": "j29",
      "source": "厚生労働省労働基準局<br>「労働者災害補償保険事業年報」"
    },
    {
      "sourceId": "j30",
      "source": "厚生労働省老健局<br>「介護保険事業状況報告年報」"
    },
    {
      "sourceId": "k01",
      "source": "消防庁防災課<br>「消防年報」<br>＜毎年＞"
    },
    {
      "sourceId": "k02",
      "source": "消防庁救急救助課<br>「救急・救助の現況」<br>＜毎年＞"
    },
    {
      "sourceId": "k03",
      "source": "消防庁防災課<br>「火災年報」<br>＜毎年＞"
    },
    {
      "sourceId": "k04",
      "source": "損害保険料率算出機構<br>｢損害保険料率算出機構統計集」<br>＜毎年＞"
    },
    {
      "sourceId": "k05",
      "source": "警察庁交通局<br>「交通統計」<br>＜毎年＞"
    },
    {
      "sourceId": "k06",
      "source": "警察庁交通局 <br>「交通事故統計年報」 <br>＜毎年＞"
    },
    {
      "sourceId": "k07",
      "source": "警察庁交通局<br>「交通統計」<br>＜毎年＞"
    },
    {
      "sourceId": "k08",
      "source": "国土交通省道路局<br>「道路統計年報」<br>＜毎年＞"
    },
    {
      "sourceId": "k09",
      "source": "損害保険料率算出機構<br>「損害保険料率算出機構統計集」<br>＜毎年＞"
    },
    {
      "sourceId": "k10",
      "source": "警察庁交通局運転免許課<br>「運転免許統計」"
    },
    {
      "sourceId": "k11",
      "source": "総務省自治行政局公務員部<br>「地方公共団体定員管理調査」<br>＜毎年＞"
    },
    {
      "sourceId": "k12",
      "source": "警察庁刑事局<br>「犯罪統計書」<br> ｢犯罪統計便覧｣<br>＜毎年＞"
    },
    {
      "sourceId": "k13",
      "source": "警察庁刑事局<br>｢犯罪統計書｣<br>｢犯罪統計便覧｣<br>＜毎年＞"
    },
    {
      "sourceId": "k14",
      "source": "警察庁刑事局<br>｢犯罪統計書｣<br>＜毎年＞"
    },
    {
      "sourceId": "k15",
      "source": "最高裁判所<br>「司法統計年報 ４少年編」<br>＜毎年＞"
    },
    {
      "sourceId": "k16",
      "source": "最高裁判所<br>「司法統計年報 １民事行政編」<br>＜毎年＞"
    },
    {
      "sourceId": "k17",
      "source": "最高裁判所<br>「司法統計年報 ３家事編」<br>＜毎年＞"
    },
    {
      "sourceId": "k18",
      "source": "警察庁刑事局<br>「犯罪統計書」<br>＜毎年＞<br>法務省<br>「検察統計年報」<br>＜毎年＞"
    },
    {
      "sourceId": "k19",
      "source": "消防庁防災情報課<br>「消防白書」<br>＜毎年＞"
    },
    {
      "sourceId": "k20",
      "source": "公害等調査委員会事務局<br>｢公害苦情調査結果報告書｣<br>＜毎年＞"
    },
    {
      "sourceId": "k21",
      "source": "環境省環境管理局大気環境課<br>「大気汚染防止法施行状況」<br>＜毎年＞"
    },
    {
      "sourceId": "k22",
      "source": "環境省環境管理局<br>水環境部水環境管理課<br>「水質汚濁防止法等の施行状況」<br>＜毎年＞"
    },
    {
      "sourceId": "k23",
      "source": "環境省地球環境局地球温暖化対策課<br>「地球温暖化対策の推進に関する法律に基づく温室効果ガス排出量算定・報告・公表制度による温室効果ガス排出量の集計結果」<br>＜毎年＞"
    },
    {
      "sourceId": "k24",
      "source": "生命保険協会<br>「生命保険事業概況」<br>＜毎年＞"
    },
    {
      "sourceId": "k25",
      "source": "日本郵政公社<br>「日本郵政公社統計データ」（簡易保険編）<br>＜毎年＞"
    },
    {
      "sourceId": "k26",
      "source": "警察庁<br>「自主防犯活動を行う地域住民・ボランティア団体の活動状況について」"
    },
    {
      "sourceId": "l01",
      "source": "農林水産省経営局<br>「農業経営統計調査報告」<br>＜毎年＞"
    },
    {
      "sourceId": "l02",
      "source": "総務省統計局<br>「家計調査年報」<br>＜毎年＞<br>数値は，各都道府県の県庁所在市の結果。"
    },
    {
      "sourceId": "l03",
      "source": "総務省統計局<br>「全国消費実態調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "l04",
      "source": "総務省統計局<br>「全国消費実態調査報告」<br>＜５年毎＞"
    },
    {
      "sourceId": "l05",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜５年毎＞<br>第３次基本集計"
    },
    {
      "sourceId": "l06",
      "source": "総務省統計局<br>「国勢調査報告」<br>＜１０年毎＞<br>大規模調査のみ<br>第２次基本集計"
    },
    {
      "sourceId": "m01",
      "source": "総務省統計局<br>「社会生活基本調査報告」<br>＜５年毎＞"
    }
  ];

export default metaSourcePref
